import {
  BankPayRequest,
  PayoneerPayRequest,
} from "../../../types/PayoutTypes";
import PayoneerRequestTable from "./PayoneerTable/PayoneerTable";

type PayoneerProps = {
  requestData: PayoneerPayRequest[];
  page: number;
  rowsPerPage: number;
  setPage: (page: number) => void;
  setRowsPerPage: (page: number) => void;
  count: number;
  setRequests: React.Dispatch<
    React.SetStateAction<{
      bankRequests: BankPayRequest[];
      payoneerRequests: PayoneerPayRequest[];
    }>
  >;
};
const Payoneer = ({
  requestData,
  page,
  rowsPerPage,
  setPage,
  setRowsPerPage,
  count,
  setRequests,
}: PayoneerProps) => {
  return (
    <div>
      <PayoneerRequestTable
        count={count}
        page={page}
        rows={requestData}
        rowsPerPage={rowsPerPage}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        setRequests={setRequests}
      />
    </div>
  );
};

export default Payoneer;
